const loadScriptPromises = {};
const loadedScripts = {};

export const promiseScriptLoader = function scriptLoader(url, crossOrigin?: 'anonymous') {
  if (loadScriptPromises[url]) {
    return loadScriptPromises[url];
  }
  const result = new Promise(function(resolve, reject) {
    if (loadedScripts[url]) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.async = true;
    if (crossOrigin) {
      script.setAttribute('crossorigin', crossOrigin);
    }
    script.addEventListener('load', () => {
      loadedScripts[url] = true;
      delete loadScriptPromises[url];
      resolve();
    });
    script.addEventListener('error', reject);
    document.body.appendChild(script);
  });

  loadScriptPromises[url] = result;
  return result;
};
